import React from 'react'
import Moment from 'moment'
import classnames from 'classnames'
import { daysOfWeek, isWeekend, datePattern } from '../../../../week'

export const daysOfWeekToDates = weekStart =>
  daysOfWeek.map(({ value }) => {
    const day = Moment(weekStart, datePattern).add(value - 1, 'day')

    return {
      label: day.format('ddd'),
      value: day.format(datePattern),
      name: day.format('dddd'),
      number: Number(day.format('d')),
    }
  })

const Day = ({ day, isEditing, children }) => (
  <div
    className={classnames({
      weekDay: true,
      weekDay__isWeekend: isWeekend(day.number),
      weekDay__isEditing: isEditing,
    })}>
    <h4>{day.label}</h4>

    {children}
  </div>
)

const Week = ({ weekStart, currentDay, render }) => (
  <fieldset>
    <div className="week">
      {daysOfWeekToDates(weekStart).map((day, i) => (
        <Day key={i} day={day} isEditing={currentDay === day.value}>
          {render({ day, dayIndex: i })}
        </Day>
      ))}
    </div>
  </fieldset>
)

export default Week



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/case-claim/form/week.jsx